import styled from 'styled-components';

export const ContainerDropdown = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export default { ContainerDropdown };
